var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBed(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 13,
    viewBox: "0 0 19 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.428711 0H3.88574V1.97902C4.02104 1.94176 4.16354 1.92186 4.31069 1.92186H5.93346C6.81532 1.92186 7.53028 2.63673 7.53028 3.51865V4.19526H15.5279C16.7028 4.19526 17.6553 5.14766 17.6553 6.32259V7.0664L18.5459 7.0664V12.5827H17.374V10.5112H1.60059V12.5827H0.428711V0ZM1.60059 8.23828V9.33932H17.374V8.23827L1.60059 8.23828ZM16.4834 7.0664V6.32259C16.4834 5.7949 16.0556 5.36713 15.5279 5.36713L3.88574 5.36713V7.06641L16.4834 7.0664ZM2.71387 7.06641V1.17187H1.60059V7.06641H2.71387ZM3.88574 4.19526L6.35841 4.19524V3.51865C6.35841 3.284 6.16817 3.09374 5.93346 3.09374H4.31069C4.07596 3.09374 3.88574 3.28398 3.88574 3.51865L3.88574 4.19526Z",
    fill: "#FE4747"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBed);
export default __webpack_public_path__ + "static/media/bed.b21fff8a8c34006e4959190653d55c79.svg";
export { ForwardRef as ReactComponent };